// extracted by mini-css-extract-plugin
export default {"contact__formId":"ContactFrom_contact__formId__B9f8j","user__message":"ContactFrom_user__message__49+VH"};